export default "__VITE_ASSET__CM05Ps0m__"